import { useCallback, useRef } from 'react'

/**
 * Rendre le focus à l'élément qui l'avait quand une boîte (ou un volet) s'est ouverte.
 *
 * Une boîte Radix pilotée par l'appelant (`open`), sans `DialogTrigger`, rend le focus à son déclencheur… qu'elle n'a
 * pas : il tombait sur la page (`body`) à sa fermeture. Mesuré dans le navigateur à la revue à froid du second retour de
 * Christophe (2026-10-12) : la confirmation « Lancer l'audit » ouverte depuis le menu de la date du bandeau rendait le
 * focus à `body`, et un utilisateur du clavier perdait sa place.
 *
 * À brancher sur `onOpenAutoFocus` (mémoriser, AVANT de déplacer le focus) et `onCloseAutoFocus` (rendre) du contenu.
 */
export function useRetourDuFocus(): { memoriser: () => void; rendre: (e: Event) => void } {
  const origine = useRef<HTMLElement | null>(null)
  const memoriser = useCallback(() => {
    const actif = document.activeElement
    origine.current = actif instanceof HTMLElement && actif !== document.body ? actif : null
  }, [])
  const rendre = useCallback((e: Event) => {
    const element = origine.current
    origine.current = null
    if (element && element.isConnected) {
      e.preventDefault()
      element.focus()
    }
  }, [])
  return { memoriser, rendre }
}
